import { render, staticRenderFns } from "./PackageFunc.vue?vue&type=template&id=a2896104&scoped=true&"
import script from "./PackageFunc.vue?vue&type=script&lang=js&"
export * from "./PackageFunc.vue?vue&type=script&lang=js&"
import style0 from "./PackageFunc.vue?vue&type=style&index=0&id=a2896104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2896104",
  null
  
)

export default component.exports